export class CurrentBuildingPostRequest {
  buildingId!: string
  constructor(buildingId:string) {
    this.buildingId = buildingId
  }
}
